export const logoNormalize = (source) => {
    return {
        idLogo: source.idLogo ?? source.IdLogo ?? 0,
        nombre: source.nombre ?? source.Nombre ?? '',
        descripcion: source.descripcion ?? source.Descripcion ?? '',
        idTipologo: source.idTipologo ?? source.IdTipologo ?? 0,
        nombreTipoLogo: source.nombreTipoLogo ?? source.NombreTipoLogo ?? '',
        imagenUrl: source.imagenUrl ?? source.ImagenUrl ?? '',
        activo: source.activo ?? source.Activo ?? false
    };
};

export const tipoLogoNormalize = (source) => {
    return {
        idTipoLogo: source.idTipoLogo ?? source.IdTipoLogo ?? 0,
        nombre: source.nombre ?? source.Nombre ?? '',
        activo: source.activo ?? source.Activo ?? false
    };
};
